import {
    CREATE_PROGRAM_MAPPING_REQUEST,
    CREATE_PROGRAM_MAPPING_SUCCESS,
    CREATE_PROGRAM_MAPPING_FAILURE,
    DELETE_PROGRAM_MAPPING_REQUEST,
    DELETE_PROGRAM_MAPPING_SUCCESS,
    DELETE_PROGRAM_MAPPING_FAILURE,
    FETCH_SINGLE_PROGRAM_MAPPING_REQUEST,
    FETCH_SINGLE_PROGRAM_MAPPING_SUCCESS,
    FETCH_SINGLE_PROGRAM_MAPPING_FAILURE,
    FETCH_PROGRAM_MAPPING_REQUEST,
    FETCH_PROGRAM_MAPPING_SUCCESS,
    FETCH_PROGRAM_MAPPING_FAILURE,
    UPDATE_PROGRAM_MAPPING_REQUEST,
    UPDATE_PROGRAM_MAPPING_SUCCESS,
    UPDATE_PROGRAM_MAPPING_FAILURE,
    RESET_PROGRAM_MAPPING_INFO,
    CREATE_PROGRAM_MAPPING_FORM,
    UPDATE_PROGRAM_MAPPING_FORM,
    FETCH_TABLE_NAMES_REQUEST,
    FETCH_TABLE_NAMES_SUCCESS,
    FETCH_TABLE_NAMES_FAILURE
} from './programMapping.actionType';

export const PROGRAM_MAPPING = 'programMapping';

let initialState = {
    loading: false,
    programMappingList: [],
    tableNameList: [],
    programMappingform: {},
    selectedState: {},
    errorMessage: ''
};

export let programMappingReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PROGRAM_MAPPING_REQUEST:
        case FETCH_TABLE_NAMES_REQUEST:
        case CREATE_PROGRAM_MAPPING_REQUEST:
        case UPDATE_PROGRAM_MAPPING_REQUEST:
        case FETCH_SINGLE_PROGRAM_MAPPING_REQUEST:
        case DELETE_PROGRAM_MAPPING_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROGRAM_MAPPING_SUCCESS:
            return {
                ...state,
                loading: false,
                programMappingList: updatePayload
            };
        case FETCH_TABLE_NAMES_SUCCESS:
            return {
                ...state,
                loading: false,
                tableNameList: updatePayload
            };
        case CREATE_PROGRAM_MAPPING_SUCCESS:
            return {
                ...state,
                loading: false,
                programMappingform: {}
            };
        case UPDATE_PROGRAM_MAPPING_SUCCESS:
            return {
                ...state,
                loading: false,
                programMappingform: {}
            };
        case FETCH_SINGLE_PROGRAM_MAPPING_SUCCESS:
            return {
                ...state,
                loading: false,
                programMappingform: {
                    ...updatePayload,
                    fldPoDcUOM: updatePayload?.tblPropertiesPoDcUOM?.fldDescription,
                    fldInwardUOM: updatePayload?.tblPropertiesInwardUOM?.fldDescription
                }
            };
        case DELETE_PROGRAM_MAPPING_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case RESET_PROGRAM_MAPPING_INFO:
            return {
                ...state,
                programMappingform: {}
            };
        case CREATE_PROGRAM_MAPPING_FORM:
        case UPDATE_PROGRAM_MAPPING_FORM:
            return {
                ...state,
                loading: false,
                programMappingform: {
                    ...state.programMappingform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PROGRAM_MAPPING_FAILURE:
        case CREATE_PROGRAM_MAPPING_FAILURE:
        case UPDATE_PROGRAM_MAPPING_FAILURE:
        case FETCH_SINGLE_PROGRAM_MAPPING_FAILURE:
        case FETCH_TABLE_NAMES_FAILURE:
        case DELETE_PROGRAM_MAPPING_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
